<template>
  <el-dialog
    :title="kind === 'inbound' ? '创建入库单' : '创建出库单'"
    :visible="true"
    width="90%"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-form inline size="small">
      <el-form-item label="货主" required>
        <el-select
          placeholder="请选择货主"
          v-model="customerId"
          :disabled="!!boundCustomerId || saving"
          filterable
          remote
          :remote-method="searchOwners"
          :loading="customerLoading"
          @change="ownerChanged"
        >
          <el-option
            v-for="c in customerOptions"
            :key="c.customerId"
            :value="c.customerId"
            :label="c.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="客户单号" required>
        <el-input v-model="customerOrderNo" maxlength="64" :disabled="saving" label="客户单号" />
      </el-form-item>
      <el-form-item label="仓库">WH01</el-form-item>
    </el-form>
    <el-alert
      v-if="error && !goodsVisible"
      :title="error"
      type="error"
      :closable="false"
    />
    <h4>已选明细</h4>
    <el-table :data="items" border>
      <el-table-column prop="itemNo" label="料号" min-width="160" />
      <el-table-column
        v-if="kind === 'inbound'"
        prop="skuName"
        label="商品名称"
        min-width="160"
      />
      <el-table-column
        v-if="kind === 'outbound'"
        prop="batchId"
        label="WMS批次"
        min-width="160"
      />
      <el-table-column
        v-if="kind === 'outbound'"
        prop="availableQty"
        label="可用数量"
        width="110"
      />
      <el-table-column label="数量" width="160"
        ><template slot-scope="scope">
          <el-input-number
            label="数量"
            v-model="scope.row.quantity"
            :min="1"
            :max="kind === 'outbound' ? scope.row.availableQty : 2147483647"
            :precision="0"
            :disabled="saving"
            controls-position="right"
            size="small"
          /> </template
      ></el-table-column>
      <el-table-column v-if="kind === 'inbound'" label="单价" width="150"
        ><template slot-scope="scope">
          <el-input
            label="单价"
            v-model="scope.row.unitPrice"
            :disabled="saving"
            size="small"
          /> </template
      ></el-table-column>
      <el-table-column v-if="kind === 'inbound'" label="币种" width="250">
        <template slot="header">
          币种
          <customs-currency-select
            data-test="batch-currency"
            style="width: 150px; margin-left: 8px;"
            :value="batchCurrency"
            :disabled="saving"
            @input="applyCurrency"
          />
        </template>
        <template slot-scope="scope">
          <customs-currency-select
            v-model="scope.row.currency"
            :disabled="saving"
          /> </template
      ></el-table-column>
      <el-table-column label="操作" width="80"
        ><template slot-scope="scope">
          <el-button
            type="text"
            :disabled="saving"
            @click="items.splice(scope.$index, 1)"
            >移除</el-button
          >
        </template></el-table-column
      >
    </el-table>
    <el-button
      v-if="kind === 'inbound'"
      data-test="choose-goods"
      :disabled="!customerId || saving"
      @click="openGoods"
      >选择备案商品</el-button
    >
    <el-dialog
      v-if="kind === 'inbound' && goodsVisible"
      title="选择备案商品"
      data-test="goods-picker"
      :visible.sync="goodsVisible"
      append-to-body
      width="75%"
      :close-on-click-modal="false"
    >
      <customize-page
        :with-card="false"
        label-position="left"
        inline
        hide-operate
        :expand-height="200"
        :loading="loading"
        :data="choices"
        :columns="goodsColumns"
        :form-config="goodsFormConfig"
        :filter-obj="filterObj"
        :pagination="{ currentPage: pageIndex, pageSize, totalCount: total }"
        @submit.native.prevent="search"
      >
        <div slot="footer">
          <el-button type="primary" data-test="search-goods" @click="search"
            >查询</el-button
          >
          <el-button data-test="reset-goods" @click="resetGoods"
            >重置</el-button
          >
        </div>
      </customize-page>
      <el-button
        slot="footer"
        data-test="finish-goods"
        @click="goodsVisible = false"
        >完成选择</el-button
      >
    </el-dialog>
    <template v-if="kind === 'outbound'">
      <h4>选择效期库存</h4>
      <el-form inline size="small" @submit.native.prevent="search">
        <el-form-item label="料号"
          ><el-input label="料号" v-model="filterObj.itemNo"
        /></el-form-item>
        <el-form-item
          ><el-button :disabled="!customerId || saving" @click="search"
            >查询</el-button
          ></el-form-item
        >
      </el-form>
      <el-table v-loading="loading" :data="choices" border>
        <el-table-column prop="itemNo" label="料号" min-width="160" />
        <el-table-column prop="stockId" label="效期库存ID" min-width="180" />
        <el-table-column prop="batchId" label="WMS批次" min-width="160" />
        <el-table-column prop="expireDate" label="失效日期" min-width="140" />
        <el-table-column label="质量类型" width="100">
          <template slot-scope="scope">
            <el-tag
              data-test="stock-quality-type"
              :type="qualityTagType(scope.row.qualityType)"
              >{{ qualityTypeName(scope.row.qualityType) }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="availableQty" label="可用数量" width="110" />
        <el-table-column label="操作" width="85"
          ><template slot-scope="scope">
            <el-button
              type="text"
              data-test="add-item"
              :disabled="
                saving ||
                  selected(scope.row) ||
                  (kind === 'outbound' && scope.row.availableQty <= 0)
              "
              @click="add(scope.row)"
              >添加</el-button
            >
          </template></el-table-column
        >
      </el-table>
      <el-pagination
        :current-page="pageIndex"
        :page-size="10"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="changePage"
      />
    </template>
    <span slot="footer"
      ><el-button :disabled="saving" @click="close">取消</el-button>
      <el-button
        type="primary"
        data-test="save-order"
        :loading="saving"
        @click="save"
        >创建</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import api from "@/api/warehouseReceipt";
import goodsApi from "@/api/goodsForRecordApi";
import CustomizePage from "@/components/customize-page";
import CustomsCurrencySelect from "@/components/CustomsCurrencySelect";
import { keepSelected, searchCustomers } from "./owner";

export default {
  components: { CustomsCurrencySelect, CustomizePage },
  provide() {
    return {
      handleCurrentChange: this.changePage,
      handleSizeChange: this.changeSize
    };
  },
  props: {
    kind: String,
    boundCustomerId: String,
    customers: Array,
    initialCustomerId: String
  },
  data() {
    return {
      customerId: this.boundCustomerId || this.initialCustomerId || "",
      customerOptions: (this.customers || []).slice(),
      customerLoading: false,
      customerSearchId: 0,
      customerOrderNo: "",
      batchCurrency: "",
      goodsVisible: false,
      items: [],
      choices: [],
      filterObj: { itemNo: "" },
      pageSize: 10,
      goodsFormConfig: [
        {
          data: [
            {
              label: "料号",
              model: "itemNo",
              type: "INPUT",
              placeholder: "可选，按料号筛选",
              props: { clearable: true }
            }
          ]
        }
      ],
      goodsColumns: [
        { title: "料号", key: "itemNo", minWidth: 160 },
        { title: "商品名称", key: "skuName", minWidth: 180 },
        {
          title: "操作",
          width: 85,
          render: (h, { row }) => (
            <el-button
              type="text"
              data-test="add-item"
              disabled={this.selected(row)}
              onClick={() => this.add(row)}
            >
              {this.selected(row) ? "已添加" : "添加"}
            </el-button>
          )
        }
      ],
      pageIndex: 1,
      total: 0,
      loading: false,
      saving: false,
      error: "",
      requestId: 0
    };
  },
  created() {
    if (this.kind === "outbound" && this.customerId) this.search();
  },
  beforeDestroy() {
    this.requestId++;
  },
  methods: {
    async searchOwners(keyword) {
      if (this.boundCustomerId) return;
      const id = ++this.customerSearchId;
      this.customerLoading = true;
      try {
        const options = await searchCustomers(keyword);
        if (id === this.customerSearchId)
          this.customerOptions = keepSelected(
            options,
            this.customerOptions,
            this.customerId
          );
      } catch (error) {
        if (id === this.customerSearchId) this.error = "货主搜索失败，请重试";
      } finally {
        if (id === this.customerSearchId) this.customerLoading = false;
      }
    },
    close() {
      if (!this.saving) this.$emit("close");
    },
    ownerChanged() {
      this.items = [];
      this.filterObj.itemNo = "";
      if (this.kind === "outbound") this.search();
    },
    openGoods() {
      this.goodsVisible = true;
      this.filterObj.itemNo = "";
      this.search();
    },
    resetGoods() {
      this.filterObj.itemNo = "";
      this.search();
    },
    changeSize(size) {
      this.pageSize = size;
      this.search();
    },
    search() {
      this.pageIndex = 1;
      this.fetch();
    },
    changePage(page) {
      this.pageIndex = page;
      this.fetch();
    },
    selected(row) {
      const key = this.kind === "inbound" ? "itemNo" : "stockId";
      return this.items.some(item => item[key] === row[key]);
    },
    qualityTypeName(value) {
      return { N: "正品", Y: "残次品" }[value] || value;
    },
    qualityTagType(value) {
      return { N: "success", Y: "danger" }[value] || "info";
    },
    add(row) {
      if (
        this.saving ||
        this.selected(row) ||
        (this.kind === "outbound" && row.availableQty <= 0)
      )
        return;
      this.items.push({
        ...row,
        quantity: 1,
        unitPrice: "",
        currency: this.batchCurrency
      });
    },
    applyCurrency(currency) {
      this.batchCurrency = currency;
      this.items.forEach(item => this.$set(item, "currency", currency));
    },
    async fetch() {
      const id = ++this.requestId;
      this.choices = [];
      this.error = "";
      if (!this.customerId) {
        this.total = 0;
        return;
      }
      this.loading = true;
      const request = {
        customerId: this.customerId,
        itemNo: this.filterObj.itemNo || undefined,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      try {
        const res =
          this.kind === "inbound"
            ? await goodsApi.list({ request })
            : await api.expiry.stock(request);
        if (id !== this.requestId) return;
        this.choices = res.items || [];
        this.total = res.page.totalCount;
      } catch (error) {
        if (id === this.requestId) this.error = "可选明细加载失败，请重试";
      } finally {
        if (id === this.requestId) this.loading = false;
      }
    },
    async save() {
      if (this.saving) return;
      if (!this.customerId || !this.items.length) {
        this.error = "请选择货主并添加明细";
        return;
      }
      if (
        this.items.some(
          item =>
            !Number.isInteger(item.quantity) ||
            item.quantity <= 0 ||
            item.quantity > 2147483647 ||
            (this.kind === "outbound" && item.quantity > item.availableQty)
        )
      ) {
        this.error = "数量必须为正整数且不能超过可用数量";
        return;
      }
      if (
        this.kind === "inbound" &&
        this.items.some(
          item =>
            !/^\d+(\.\d+)?$/.test(item.unitPrice) ||
            Number(item.unitPrice) <= 0 ||
            !item.currency
        )
      ) {
        this.error = "请填写正数单价并选择币种";
        return;
      }
      const customerOrderNo = this.customerOrderNo.trim();
      if (!customerOrderNo || customerOrderNo.length > 64) {
        this.error = "客户单号必填，最多64字符";
        return;
      }
      this.saving = true;
      this.error = "";
      try {
        const items = this.items.map(item =>
          this.kind === "inbound"
            ? {
                itemNo: item.itemNo,
                quantity: item.quantity,
                unitPrice: item.unitPrice,
                currency: item.currency
              }
            : { stockId: item.stockId, quantity: item.quantity }
        );
        const res = await api[this.kind].create({
          customerId: this.customerId,
          customerOrderNo,
          items
        });
        if (!res || !res.value) throw new Error("创建未返回单号");
        this.$emit("saved", res.value);
      } catch (error) {
        this.error = error.msg || error.message || "创建失败，请刷新后确认结果";
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
